module.exports = __webpack_public_path__ + "img/538.d8e3d9d7.png";